import { gql } from 'apollo-boost';

export const UPDATE_BUSINESS = gql`
  mutation BusinessUpdate(
    $input: BusinessUpdateInput!
  ) {
    business_update(input: $input) {
      business {
        id
        name
        tier
        street_1
        street_2
        city
        state
        zip
        url
        phone_number
        hours_of_operation {
          id
          all_day
          closed
          close
          open
        }
        business_features {
          auditions
          bookings
          audition_limits {
            applications_max
            duration_max
          }
        }
        organization {
          id
        }
        active
        allow_dancer_reviews
        free_agent_search_enabled
        allow_under_21_dancers
        number_of_stages
        square_footage
        max_consecutive_shift_count
        min_dancers_for_free_agent_search
        free_agent_search_enabled
        dancer_count
        profile_options {
          id
          name
          trans_key
        }
        required_documents
        special_requirements
        special_requirements_link

        audition_info
        notes
        message_club
        auditions_enabled
        audition_duration_max
        audition_applications_max
        auditions_daily_max
      }
    }
  }
`;
